import ContractorCard from "../../permitComponents/ContractorCard";

import { Typography, useMediaQuery, Box, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const ChangePlanContractor = (props) => {
  const mobileSize = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleNavigate = (direction) => {
    let newPage;
    if (direction === "forward") {
      newPage = props?.contractorIndex + 1;
    } else if (direction === "back") {
      newPage = props?.contractorIndex - 1;
    }

    props?.setContractorIndex(newPage);
  };

  const contractorLenghtContent = () =>
    props?.type === "subscription" &&
    props?.currentUser?.user?.contractors?.length === 0 ? (
      <Typography align="center" variant="h5">
        0/0
      </Typography>
    ) : (
      <Typography align="center" variant="h5">
        {props?.contractorIndex +
          1 +
          "/" +
          props?.currentUser?.user?.contractors?.length}
      </Typography>
    );

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "100%",
          flexWrap: "wrap",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "flex-end",
            order: 1,
          }}
        >
          <IconButton
            onClick={() => handleNavigate("back")}
            sx={{
              display:
                props?.contractorIndex === 0 ||
                props?.currentUser?.user?.contractors?.length <= 1
                  ? "none"
                  : "inline-flex",
            }}
          >
            <ArrowBackIosNewIcon
              sx={{ fontSize: mobileSize ? "32px" : "60px", color: "#d3d3d3" }}
            />
          </IconButton>
        </Box>
        {mobileSize && <Box sx={{ order: 2 }}>{contractorLenghtContent()}</Box>}

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            order: mobileSize ? 3 : 2,
            flexBasis: mobileSize ? "100%" : "auto",
          }}
        >
          <ContractorCard
            data={
              props?.currentUser?.user?.contractors?.[props?.contractorIndex]
            }
            mb={4}
            colorIndex={props?.contractorIndex}
            empty={props?.currentUser?.user?.contractors.length === 0}
            showLicenseInput={false}
            deleteLicenses={props?.deleteLicenses}
            currLicense={
              props?.currentUser?.user?.contractors[props?.contractorIndex]
                ?.licenseNumber
            }
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flex: 1,
            alignItems: "center",
            order: mobileSize ? 2 : 3,
          }}
        >
          <IconButton
            onClick={() => handleNavigate("forward")}
            sx={{
              display:
                props?.currentUser?.user?.contractors?.length <= 0 ||
                props?.contractorIndex + 1 ===
                  props?.currentUser?.user?.contractors?.length
                  ? "none"
                  : "inline-flex",
            }}
          >
            <ArrowForwardIosIcon
              sx={{ fontSize: mobileSize ? "32px" : "60px", color: "#d3d3d3" }}
            />
          </IconButton>
        </Box>
      </Box>
      {!mobileSize && contractorLenghtContent()}
    </>
  );
};

export default ChangePlanContractor;
